export const commaListParser = (list: any[]) =>
  list?.map(({ name }) => name).join(', ');

export const minMaxToStringArrayParser = (value: any) => {
  const result = [];

  value?.min && result.push(value.min);
  value?.max && result.push(value.max);

  return result;
};
